/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */

// Mantine
import {
	Title as NativeTitle,
	TitleProps,
} from '@mantine/core';

// Styles
import classes from './Title.module.css';

/* -------------------------------------------------------------------------- */
/*                                  Component                                 */
/* -------------------------------------------------------------------------- */
export const Title = (props: TitleProps) => {
	/* ******************************** RENDERING ******************************* */
	return <NativeTitle classNames={classes} {...props} />;
};
